// Generated by scripts/make_term_audio.py: spoken pronunciation for each musical term.
export const TERM_AUDIO = {
 "pianissimo": "/media/terms/pianissimo.mp3",
 "piano": "/media/terms/piano.mp3",
 "mezzo piano": "/media/terms/mezzo-piano.mp3",
 "mezzo forte": "/media/terms/mezzo-forte.mp3",
 "forte": "/media/terms/forte.mp3",
 "fortissimo": "/media/terms/fortissimo.mp3",
 "crescendo (cresc.)": "/media/terms/crescendo-cresc.mp3",
 "diminuendo (dim.)": "/media/terms/diminuendo-dim.mp3",
 "decrescendo": "/media/terms/decrescendo.mp3",
 "sforzando": "/media/terms/sforzando.mp3",
 "forte-piano": "/media/terms/forte-piano.mp3",
 "M.M.": "/media/terms/m-m.mp3",
 "Largo": "/media/terms/largo.mp3",
 "Adagio": "/media/terms/adagio.mp3",
 "Andante": "/media/terms/andante.mp3",
 "Moderato": "/media/terms/moderato.mp3",
 "Allegretto": "/media/terms/allegretto.mp3",
 "Allegro": "/media/terms/allegro.mp3",
 "Presto": "/media/terms/presto.mp3",
 "ritardando / ritenuto": "/media/terms/ritardando-ritenuto.mp3",
 "rallentando": "/media/terms/rallentando.mp3",
 "accelerando": "/media/terms/accelerando.mp3",
 "a tempo": "/media/terms/a-tempo.mp3",
 "pause (fermata)": "/media/terms/pause-fermata.mp3",
 "rubato": "/media/terms/rubato.mp3",
 "staccato": "/media/terms/staccato.mp3",
 "legato / slur": "/media/terms/legato-slur.mp3",
 "accent": "/media/terms/accent.mp3",
 "tenuto": "/media/terms/tenuto.mp3",
 "phrase mark": "/media/terms/phrase-mark.mp3",
 "cantabile": "/media/terms/cantabile.mp3",
 "dolce": "/media/terms/dolce.mp3",
 "espressivo": "/media/terms/espressivo.mp3",
 "grazioso": "/media/terms/grazioso.mp3",
 "leggiero": "/media/terms/leggiero.mp3",
 "maestoso": "/media/terms/maestoso.mp3",
 "con": "/media/terms/con.mp3",
 "senza": "/media/terms/senza.mp3",
 "molto": "/media/terms/molto.mp3",
 "poco": "/media/terms/poco.mp3",
 "più / meno": "/media/terms/piu-meno.mp3",
 "sempre": "/media/terms/sempre.mp3",
 "subito": "/media/terms/subito.mp3",
 "ma non troppo": "/media/terms/ma-non-troppo.mp3",
 "da capo": "/media/terms/da-capo.mp3",
 "dal segno": "/media/terms/dal-segno.mp3",
 "fine": "/media/terms/fine.mp3",
 "repeat marks": "/media/terms/repeat-marks.mp3",
 "1st & 2nd time bars": "/media/terms/1st-2nd-time-bars.mp3",
 "coda": "/media/terms/coda.mp3",
 "sostenuto": "/media/terms/sostenuto.mp3",
 "tranquillo": "/media/terms/tranquillo.mp3",
 "vivace": "/media/terms/vivace.mp3",
 "con moto": "/media/terms/con-moto.mp3",
 "giocoso": "/media/terms/giocoso.mp3",
 "simile": "/media/terms/simile.mp3",
 "ottava": "/media/terms/ottava.mp3",
 "Maelzel's metronome": "/media/terms/maelzel-s-metronome.mp3",
 "ad libitum": "/media/terms/ad-libitum.mp3",
 "al fine": "/media/terms/al-fine.mp3",
 "assai": "/media/terms/assai.mp3",
 "mezzo": "/media/terms/mezzo.mp3",
 "animato": "/media/terms/animato.mp3",
 "con forza": "/media/terms/con-forza.mp3",
 "deciso": "/media/terms/deciso.mp3",
 "delicato": "/media/terms/delicato.mp3",
 "energico": "/media/terms/energico.mp3",
 "pesante": "/media/terms/pesante.mp3",
 "morendo": "/media/terms/morendo.mp3",
 "smorzando": "/media/terms/smorzando.mp3",
 "sotto voce": "/media/terms/sotto-voce.mp3",
 "stringendo": "/media/terms/stringendo.mp3",
 "tempo primo": "/media/terms/tempo-primo.mp3",
 "attacca": "/media/terms/attacca.mp3",
 "lent": "/media/terms/lent.mp3",
 "vite": "/media/terms/vite.mp3",
 "très": "/media/terms/tres.mp3",
 "modéré": "/media/terms/modere.mp3",
 "avec": "/media/terms/avec.mp3",
 "retenu": "/media/terms/retenu.mp3",
 "langsam": "/media/terms/langsam.mp3",
 "schnell": "/media/terms/schnell.mp3",
 "sehr": "/media/terms/sehr.mp3",
 "mit": "/media/terms/mit.mp3",
 "etwas": "/media/terms/etwas.mp3",
 "ruhig": "/media/terms/ruhig.mp3",
 "alla marcia": "/media/terms/alla-marcia.mp3",
 "brillante": "/media/terms/brillante.mp3",
 "comodo": "/media/terms/comodo.mp3",
 "nobilmente": "/media/terms/nobilmente.mp3",
 "piacevole": "/media/terms/piacevole.mp3",
 "scherzando": "/media/terms/scherzando.mp3",
 "pedal": "/media/terms/pedal.mp3",
 "una corda": "/media/terms/una-corda.mp3",
 "tre corde": "/media/terms/tre-corde.mp3",
 "mano destra / sinistra": "/media/terms/mano-destra-sinistra.mp3",
 "volti subito": "/media/terms/volti-subito.mp3",
 "ben": "/media/terms/ben.mp3",
 "dolente": "/media/terms/dolente.mp3",
 "l'istesso tempo": "/media/terms/l-istesso-tempo.mp3",
 "marcato": "/media/terms/marcato.mp3",
 "non troppo": "/media/terms/non-troppo.mp3",
 "quasi": "/media/terms/quasi.mp3",
 "ritmico": "/media/terms/ritmico.mp3",
 "semplice": "/media/terms/semplice.mp3",
 "sonoro": "/media/terms/sonoro.mp3",
 "spiritoso": "/media/terms/spiritoso.mp3",
 "vivo": "/media/terms/vivo.mp3",
 "cédez": "/media/terms/cedez.mp3",
 "doux": "/media/terms/doux.mp3",
 "vif": "/media/terms/vif.mp3",
 "lebhaft": "/media/terms/lebhaft.mp3",
 "mässig": "/media/terms/massig.mp3",
 "zart": "/media/terms/zart.mp3",
 "arco": "/media/terms/arco.mp3",
 "pizzicato": "/media/terms/pizzicato.mp3",
 "con sordino": "/media/terms/con-sordino.mp3",
 "divisi": "/media/terms/divisi.mp3",
 "a due": "/media/terms/a-due.mp3",
 "tutti": "/media/terms/tutti.mp3"
};
